import { render, staticRenderFns } from "./NewUsers.vue?vue&type=template&id=01aff64a&scoped=true&"
import script from "./NewUsers.vue?vue&type=script&lang=js&"
export * from "./NewUsers.vue?vue&type=script&lang=js&"
import style0 from "./NewUsers.vue?vue&type=style&index=0&id=01aff64a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aff64a",
  null
  
)

export default component.exports